import React from "react"
import {RouteComponentProps} from "react-router"
import {useTranslation} from "react-i18next"

import {useDataSources as useItems} from "../../contexts/DataSourceContext"

import ItemView from "../../components/DataSources/View"
import PageItem from "../common/Item"
import NotFound from "../../components/DataSources/NotFound"
import DataSourceSyncList from "../../components/DataSources/DataSourceSyncs/List";

interface pageProps extends RouteComponentProps<{
    id:      string;
    segment: string;
}> {}

const PageDataSourcesItem: React.FC<pageProps> = ({ match }) => {
    const { t }        = useTranslation()
    const { fetchItems, items} = useItems()

    const
        itemType:     string = 'DataSource',
        itemTypeName: string = t('data-sources.title_item'),
        itemTypeUrl:  string = 'data-sources'

    return (
        <PageItem
            useItems={useItems}
            fetchItems={fetchItems}
            itemId={match.params.id}
            items={items}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            ItemNotFound={NotFound}
            ItemView={ItemView}
            DataSourceSyncList={DataSourceSyncList}
            segment={match.params.segment}
        />
    )
}

export default PageDataSourcesItem